module.exports = __webpack_public_path__ + "media/images/pepsi-south-new-a075e1a9e6b5719f69c60c2a4842c627.png";